import { useLayout } from "@/lib/preFetch/preFetchLayout"
import { Link, TrustedShopWidget, useNoticeBar } from "@jog/react-components"
import { CSSProperties, useMemo, useRef } from "react"

interface DivProperties extends CSSProperties {
    ["--y-scroll"]: string
}
export const UspBar = () => {
    const layout = useLayout()
    const ref = useRef<HTMLDivElement>(null)
    const headerLinks = useMemo(() => layout?.layout?.headerLinks || [], [layout?.layout?.headerLinks])
    const transform = useNoticeBar(ref)
    const style: DivProperties = { ["--y-scroll"]: transform }
    return (
        <div className="relative z-[11] flex h-6 w-full items-center justify-center overflow-hidden bg-gray-dracula lg:h-auto lg:overflow-visible">
            <div
                ref={ref}
                className="block h-6 translate-y-[var(--y-scroll)] no-underline transition-transform duration-300 ease-out lg:flex lg:h-auto lg:translate-y-0 lg:space-x-10 lg:py-2"
                style={style}>
                {headerLinks?.map((item, index) => (
                    <div className="flex h-6 items-center justify-center lg:h-auto" key={index}>
                        <Link to={item.link} className="uspIcon truncate text-xs uppercase text-white no-underline">
                            {item.label}
                        </Link>
                    </div>
                ))}
                <TrustedShopWidget className="flex h-6 items-center justify-center lg:h-auto" />
            </div>
        </div>
    )
}
